import React, { FC, useMemo } from "react";
import { Header } from "custom";
import Main from "./Main";
import HeaderElements from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "store/store.interface";
import { Box, Text } from "common";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { setLocation } from "store/actions/auth.actions";
import { ERoles } from "store/reducers/auth.reducers";

const Layout: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { name, email, roles, scopes,  bundleAllowedCountries =[], recurringCountries = [], storeId} = useSelector((state: IState) => ({
    ...state.auth,
    ...state.config,
  }));

  const dropMenuRoutes = useMemo(() => {
    const routes = [
      { label: "My Profile", to: "/my-profile" },
      { label: "Logout", to: "/logout" },
    ];
    if (roles?.includes(ERoles.ADMIN)) {
      routes.unshift({ label: "Users", to: "/users" });
    }
    return routes;
  }, [roles]);

  const roleName = useMemo(() => {
    const role = roles?.[0];
    return role ? scopes?.[role]?.text : undefined;
  }, [roles, scopes]);

  const dispatch = useDispatch();

  const onLogoClick = () => {
    dispatch(setLocation("/"));
  };

  const menuLabel = useMemo(() => {
    return (
      <Box display="flex" justifyContent="center">
        <AccountCircle color="primary" />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          marginLeft="6px"
          maxWidth="125px"
          overflow="hidden"
        >
          <Text
            fontSize="10px"
            fontWeight={500}
            marginBottom="3px"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            Hi, {name || email}
          </Text>
          {roleName && (
            <Text
              fontSize="9px"
              color="primary.main"
              whiteSpace="nowrap"
              textAlign="left"
            >
              {roleName}
            </Text>
          )}
        </Box>
      </Box>
    );
  }, [roleName, name, email]);
  return (
    <>
      <Header
        menuLabel={menuLabel}
        dropMenuRoutes={dropMenuRoutes}
        onLogoClick={onLogoClick}
      >
        <HeaderElements />
      </Header>
      <Main 
      sx={storeId && (bundleAllowedCountries.includes(storeId) || recurringCountries.includes(storeId)) ? {marginTop:'30px'}: undefined}>
        {children}
        </Main>
    </>
  );
};

export default Layout;
